import $ from '@vaersaagod/tools/Dom';
import Viewport from '@vaersaagod/tools/Viewport';

import '../lib/SplitText';

export default el => {
    const dom = $(el);

    const text = dom.find('[data-text]').get(0);
    const image = dom.find('[data-image]').get(0);
    const scroller = dom.find('[data-scroller]').get(0);

    let split = new SplitText(text, { type: 'lines' });
    let items = split.lines;

    const onResize = () => {
        if (split) {
            split.revert();
            split = false;
        }
        // Only split if we need to
        if (Viewport.width > 1200) {
            split = new SplitText(text, { type: 'lines' });
            items = split.lines;
        }
    };

    const init = () => {
        if (Viewport.width > 1200) {
            let delay = 0.25;

            TweenLite.set(items, { opacity: 0, x: 50 });
            TweenLite.set(image, { opacity: 0, x: 75 });
            TweenLite.set(scroller, { opacity: 0, y: 15 });

            TweenLite.to(image, 1.5, { delay, x: 0, ease: Expo.easeOut });
            TweenLite.to(image, 0.3, { delay, opacity: 1, ease: Sine.easeOut });

            delay += 0.3;

            items.forEach(node => {
                TweenLite.to(node, 1.5, { delay, x: 0, ease: Expo.easeOut });
                TweenLite.to(node, 0.55, { delay, opacity: 1, ease: Sine.easeOut });
                delay += 0.075;
            });

            TweenLite.to(scroller, 1.5, { delay, y: 0, ease: Expo.easeOut });
            TweenLite.to(scroller, 0.55, { delay, opacity: 1, ease: Sine.easeOut });
        } else {
            text.setAttribute('data-reveal', '');
            scroller.setAttribute('data-reveal', '');
            image.setAttribute('data-reveal', '');
        }
        Viewport.on('resize', onResize);
    };

    const destroy = () => {};

    return {
        init,
        destroy
    };
};



// WEBPACK FOOTER //
// ./src/js/components/HeroFrontpage.js